import {message} from '@common/i18n/message';
import {SettingsNavItem} from '@common/admin/settings/settings-nav-config';

export const AppSettingsNavConfig: SettingsNavItem[] = [
  {label: message('Drive'), to: 'drive'},
];
